import axios from 'axios'

let isRedirecting = false

export const setupAxiosInterceptors = () => {
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error?.response?.status
      const skipAuthRedirect = error?.config?.skipAuthRedirect

      if ((status === 401 || status === 403) && !isRedirecting && !skipAuthRedirect) {
        isRedirecting = true

        localStorage.removeItem('a')
        localStorage.removeItem('idClient')
        localStorage.removeItem('emailClient')
        localStorage.removeItem('nameClient')

        delete axios.defaults.headers.common['Authorization']

        window.location.assign('/') 
      }

      return Promise.reject(error)
    }
  )
}
